import type { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

 export default {
    item: {
        gap: "{navigation.item.gap}",
        icon: {
            color: "{link.color}",
            hoverColor: "{link.hover.color}"
        },
        color: "{link.color}",
        focusRing: {
            color: "{focus.ring.color}",
            style: "{focus.ring.style}",
            width: "{focus.ring.width}",
            offset: "{focus.ring.offset}",
            shadow: "{focus.ring.shadow}"
        },
        hoverColor: "{link.hover.color}",
        borderRadius: "{content.border.radius}"
    },
    root: {
        gap: "0.5rem",
        padding: "0px",
        background: "{transparent}",
        transitionDuration: "{transition.duration.xxs}"
    },
    separator: {
        color: "{navigation.item.icon.color}"
    }
} satisfies BreadcrumbDesignTokens;